import { render } from "./marketingSms.vue?vue&type=template&id=108e546c"
import script from "./marketingSms.vue?vue&type=script&lang=js"
export * from "./marketingSms.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__